/* Мобільні слайдери товарів (Popular, Recently viewed, рекомендації): видно край наступної
   картки — підказка, що ряд гортається. Рекомендації довантажуються пізніше, тому перевіряємо
   кілька разів після завантаження, при появі нових слайдерів і після повороту екрана. */
(function () {
  function tune() {
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.product-swipe-slider .swiper').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || sw.destroyed) return;
      /* 02.10 (Яна): на сторінці товару картки рекомендацій на всю ширину, як картки в категоріях */
      var full = !!el.closest('.grid__single-product-template');
      var spv = full ? 1 : 1.12, gap = full ? 16 : 12;
      if (sw.params.slidesPerView === spv && sw.params.spaceBetween === gap) return;
      sw.params.slidesPerView = spv;
      sw.params.spaceBetween = gap;
      sw.update();
    });
  }
  function burst() { var n = 0; var t = setInterval(function () { tune(); if (++n >= 24) clearInterval(t); }, 500); }
  window.addEventListener('load', burst);
  if (document.readyState === 'complete') burst();
  window.addEventListener('resize', function () { setTimeout(tune, 80); });
  document.addEventListener('shopify:section:load', function () { setTimeout(tune, 300); });
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () { if (pending) return; pending = setTimeout(function () { pending = null; tune(); }, 400); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Скін карток v2 (ap-cards-v2.css, префікс .ap-has-anchors) на слайдерах головної
   та сторінок товару: на колекціях клас уже стоїть на .container. */
(function () {
  function skin() {
    document.querySelectorAll('.product-swipe-slider').forEach(function (el) {
      if (!el.closest('.ap-has-anchors')) el.classList.add('ap-has-anchors');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', skin); else skin();
  document.addEventListener('shopify:section:load', skin);
})();

/* Страховка від «дірки» між промо-смужкою і шапкою (29.09.2026).
   Тема один раз міряє низ смужки eSputnik і кладе його в --promo-bar-height; якщо замір зроблено
   невчасно (смужка ще мала іншу висоту, шрифт не довантажився, Safari), шапка лишається нижче.
   Тут значення звіряється з реальним низом смужки після завантаження, зміни розміру і прокрутки. */
(function () {
  function sync() {
    var bar = document.querySelector('.cl-floating-bar');
    var body = document.body;
    if (!body) return;
    if (!bar) return;
    var r = bar.getBoundingClientRect();
    if (!r.height) return;
    var want = Math.max(0, Math.round(r.bottom)) + 'px';
    if (body.style.getPropertyValue('--promo-bar-height') !== want) body.style.setProperty('--promo-bar-height', want);
  }
  var t = null;
  function soon() { if (t) return; t = setTimeout(function () { t = null; sync(); }, 120); }
  window.addEventListener('load', function () { var n = 0; var i = setInterval(function () { sync(); if (++n >= 20) clearInterval(i); }, 500); });
  window.addEventListener('resize', soon);
  window.addEventListener('orientationchange', soon);
  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('pageshow', soon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
})();

/* 05.10 (Яна): селектор Amount на мобайлі. Відкритим лишається лише один список, тап поза ним закриває
   (і той самий тап не відкриває картку), а якщо список виходить за нижній край екрана, сторінка трохи прокручується.
   Відкриття/закриття по тапу робить тема (redesign.js, jQuery). Тут без jQuery: на сторінці дві його версії. */
(function () {
  function isMobile() { return window.innerWidth <= 767; }
  function isOpen(el) { return el && getComputedStyle(el).display !== 'none'; }
  function syncChat() { document.body.classList.toggle('ap-list-open', openLists().length > 0); }
  function close(sel) {
    sel.style.display = 'none';
    setTimeout(syncChat, 0);
    var form = sel.closest('.product-card-form');
    if (!form) return;
    form.querySelectorAll('.toggle-selector').forEach(function (t) { t.classList.remove('active'); });
    form.querySelectorAll('.buy-btn').forEach(function (b) { b.classList.remove('hover'); });
  }
  function openLists() { return Array.prototype.filter.call(document.querySelectorAll('.variant-selector'), isOpen); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.toggle-selector');
    if (!t || !isMobile()) return;
    var form = t.closest('.product-card-form');
    var sel = form && form.querySelector('.variant-selector');
    setTimeout(function () {
      openLists().forEach(function (o) { if (o !== sel) close(o); });
      syncChat();
      if (!isOpen(sel)) return;
      var r = sel.getBoundingClientRect();
      var hdr = document.querySelector('header.header'), hb = hdr ? hdr.getBoundingClientRect().bottom : 0;
      /* 15.10: панель поверх картки — якщо її верх під шапкою сайту, підкручуємо вгору, інакше вниз, щоб було видно всю */
      if (r.top < hb + 8) window.scrollBy({ top: r.top - hb - 12, behavior: 'smooth' });
      else if (r.bottom > window.innerHeight - 12) window.scrollBy({ top: Math.min(r.bottom - window.innerHeight + 24, r.top - hb - 12), behavior: 'smooth' });
    }, 30);
  });
  var closedAt = 0;
  function closeOutside(e) {
    if (!isMobile()) return false;
    if (e.target.closest && e.target.closest('.variant-selector, .toggle-selector')) return false;
    /* 15.10: клік по Add to Cart (зокрема програмний після вибору варіанта в темі) не глушимо:
       список закриваємо, але сабміт форми лишаємо, інакше товар не додається в кошик. */
    if (e.target.closest && e.target.closest('.buy-btn')) { openLists().forEach(close); return false; }
    var lists = openLists();
    lists.forEach(close);
    if (lists.length) closedAt = Date.now();
    return lists.length > 0;
  }
  document.addEventListener('touchstart', closeOutside, { capture: true, passive: true });
  document.addEventListener('click', function (e) {
    if (closeOutside(e) || (closedAt && Date.now() - closedAt < 700)) { e.preventDefault(); e.stopPropagation(); closedAt = 0; }
  }, true);
})();

/* 05.10 (Яна): відгуки-слайдер section-stories (Organic Promotion, Radio). Стрічка гортається в межах
   контейнера (CSS), стрілки зсувають на одну картку, крапки показують реальну позицію.
   Старий скрипт теми зсував усю обгортку через margin-left — перехоплюємо кліки по стрілках раніше за нього.
   Якщо тема вже зробила з відгуків Swiper (Radio на мобайлі), нічого не чіпаємо. */
(function () {
  function setup(sec) {
    if (sec.__apStories) return;
    var slider = sec.querySelector('.stories-slider');
    if (!slider || slider.classList.contains('swiper')) return;
    var box = slider.parentElement;
    sec.__apStories = true;
    var cards = Array.prototype.slice.call(slider.children).filter(function (c) { return c.offsetWidth > 0; });
    function step() {
      var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
      return cards.length ? cards[0].getBoundingClientRect().width + gap : box.clientWidth;
    }
    function pages() { var per = Math.max(1, Math.round((box.clientWidth + 1) / step())); return Math.max(1, cards.length - per + 1); }
    function index() { return Math.round(box.scrollLeft / step()); }
    var pag = sec.querySelector('.stories-pag');
    function renderDots() {
      if (!pag) return;
      var n = pages();
      pag.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var d = document.createElement('span');
        d.className = 'stories-dot';
        d.setAttribute('data-i', i);
        pag.appendChild(d);
      }
      pag.style.display = n > 1 ? '' : 'none';
      sync();
    }
    function sync() {
      var i = Math.min(index(), pages() - 1);
      if (pag) Array.prototype.forEach.call(pag.children, function (d, k) { d.classList.toggle('active', k === i); });
      var prev = sec.querySelector('.left-arrow'), next = sec.querySelector('.right-arrow');
      if (prev) prev.classList.toggle('is-disabled', i <= 0);
      if (next) next.classList.toggle('is-disabled', i >= pages() - 1);
    }
    sec.__apGo = function (dir) { box.scrollBy({ left: dir * step(), behavior: 'smooth' }); };
    sec.__apTo = function (i) { box.scrollTo({ left: i * step(), behavior: 'smooth' }); };
    var t = null;
    box.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    window.addEventListener('resize', function () { setTimeout(renderDots, 120); });
    var w = sec.querySelector('.stories-wrapper'); if (w) w.style.marginLeft = '0';
    renderDots();
  }
  function init() { document.querySelectorAll('.section-stories').forEach(setup); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.section-stories .left-arrow, .section-stories .right-arrow, .section-stories .stories-dot');
    if (!a) return;
    var sec = a.closest('.section-stories');
    if (!sec || !sec.__apStories) return;
    e.preventDefault(); e.stopPropagation();
    if (a.classList.contains('stories-dot')) sec.__apTo(+a.getAttribute('data-i') || 0);
    else sec.__apGo(a.classList.contains('left-arrow') ? -1 : 1);
  }, true);
  /* після DOMContentLoaded-обробників теми (Swiper для відгуків на мобайлі), з запасом на load */
  document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  window.addEventListener('load', init);
  if (document.readyState === 'complete') init();
})();

/* 15.10 (Яна): панель варіантів поверх картки (CSS в ap-cards-v2.css). Тут: шапка з назвою товару і хрестиком,
   закриття по хрестику, підсвітка обраного рядка і ціна обраного варіанта на картці замість «From $N». */
(function () {
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var de = /^de/i.test(document.documentElement.lang || '');
  function subtitle(label) {
    var l = (label || '').toLowerCase();
    if (l.indexOf('genre') > -1) return de ? 'Genre wählen' : 'Choose genre';
    if (l.indexOf('day') > -1 || l.indexOf('tag') > -1) return de ? 'Tage wählen' : 'Choose days';
    if (l.indexOf('blog') > -1 || l.indexOf('name') > -1) return de ? 'Auswählen' : 'Choose an option';
    return de ? 'Menge wählen' : 'Choose amount';
  }
  function ensureHead(sel) {
    if (!sel || sel.querySelector('.ap-vs-head') || !sel.closest('.ap-has-anchors')) return;
    var form = sel.closest('.product-card-form'), card = sel.closest('.grid__product-card');
    var title = (form && form.getAttribute('data-title') || '').replace(/\s+/g, ' ').trim();
    if (!title && card) { var t = card.querySelector('.ap-pkg-name, .grid__product-title'); title = t ? t.textContent.replace(/\s+/g, ' ').trim() : ''; }
    var toggle = form && form.querySelector('.toggle-selector');
    var head = document.createElement('div');
    head.className = 'ap-vs-head';
    head.innerHTML = '<div><b></b><small></small></div><button type="button" class="ap-vs-close" aria-label="Close">' + CLOSE_SVG + '</button>';
    head.querySelector('b').textContent = title;
    head.querySelector('small').textContent = subtitle(toggle && toggle.getAttribute('data-label'));
    sel.insertBefore(head, sel.firstChild);
  }
  function ensureAll() { document.querySelectorAll('.ap-has-anchors .variant-selector').forEach(ensureHead); }
  function closeSel(sel) {
    if (!sel) return;
    sel.style.display = 'none';
    var form = sel.closest('.product-card-form');
    if (form) {
      form.querySelectorAll('.toggle-selector').forEach(function (t) { t.classList.remove('active'); });
      form.querySelectorAll('.buy-btn').forEach(function (b) { b.classList.remove('hover'); });
    }
    var anyOpen = Array.prototype.some.call(document.querySelectorAll('.variant-selector'), function (v) { return getComputedStyle(v).display !== 'none'; });
    if (!anyOpen) document.body.classList.remove('ap-list-open');
  }
  function fmt(n) {
    var s = (Math.round(n * 100) / 100);
    var whole = Math.floor(s), frac = Math.round((s - whole) * 100);
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return frac ? w + '.' + (frac < 10 ? '0' + frac : frac) : w;
  }
  function showPrice(opt) {
    var card = opt.closest('.grid__product-card'), box = card && card.querySelector('.grid__product-price');
    var sale = box && box.querySelector('.grid__product-sale-price');
    var p = parseFloat(opt.getAttribute('data-price'));
    if (!sale || isNaN(p)) return;
    var cur = (sale.textContent.match(/^\s*([^\d\s]+)/) || [])[1] || '$';
    sale.textContent = cur + fmt(p);
    Array.prototype.forEach.call(box.childNodes, function (n) { if (n.nodeType === 3) n.textContent = ''; });
    var old = box.querySelector('.grid__product-old-price');
    if (old) old.style.display = 'none';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.toggle-selector');
    if (t) { var f = t.closest('.product-card-form'); ensureHead(f && f.querySelector('.variant-selector')); return; }
    var c = e.target.closest && e.target.closest('.ap-vs-close');
    if (c) { e.preventDefault(); e.stopPropagation(); closeSel(c.closest('.variant-selector')); return; }
    var o = e.target.closest && e.target.closest('.ap-has-anchors .variant-option');
    if (o) {
      var sel = o.closest('.variant-selector');
      if (sel) sel.querySelectorAll('.variant-option.selected').forEach(function (x) { x.classList.remove('selected'); });
      o.classList.add('selected');
      showPrice(o);
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureAll); else ensureAll();
  window.addEventListener('load', ensureAll);
})();

/* 28.10.2026 (Яна): скільки людей додають 2-й / 3-й товар. Після кожного успішного /cart/add (fetch або jQuery XHR)
   у dataLayer іде подія ap_add_position: cart_items (позицій у кошику після додавання), cart_position (1 | 2 | 3plus),
   add_source (product | collection | popup_reco | cart_reco | recently_viewed | other), offer_shown (5 | 10 | none —
   яка плашка про знижку була на екрані в момент кліку). GTM-MNX57X3: тригер CE - ap_add_position → тег GA4. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var RE = /\/cart\/add(\.js)?(\?|$)/;
  var lastSource = 'other', lastOffer = 'none', lastAt = 0;
  function visible(el) { return !!el && el.offsetParent !== null && getComputedStyle(el).display !== 'none'; }
  function offerNow() {
    if (visible(document.querySelector('#ap-popup-reco .ap-prc__lead--offer'))) return '10';
    var lbl = document.getElementById('_add_to_bag-notification-discount-label');
    if (visible(lbl) && !lbl.classList.contains('applied')) return '5';
    var msg = document.querySelector('.ap-reco__msg');
    if (visible(msg)) { var t = msg.textContent || ''; if (/applied/i.test(t)) return 'none'; if (/10%/.test(t)) return '10'; if (/5%/.test(t)) return '5'; }
    return 'none';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button, [type="submit"], .buy-btn, .variant-option');
    if (!t) return;
    var src;
    if (t.closest('#ap-popup-reco')) src = 'popup_reco';
    else if (t.closest('#ap-upsell')) src = 'cart_reco';
    else if (t.closest('.recently-viewed')) src = 'recently_viewed';
    else if (t.closest('.product-card-form')) src = 'collection';
    else if (t.closest('.product-form')) src = 'product';
    else return;
    lastSource = src; lastOffer = offerNow(); lastAt = Date.now();
  }, true);
  function report() {
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = ((c && c.items) || []).length, fresh = Date.now() - lastAt < 5000;
      var pos = n <= 1 ? '1' : n === 2 ? '2' : '3plus';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ap_add_position', cart_items: n, cart_position: pos, add_source: fresh ? lastSource : 'other', offer_shown: fresh ? lastOffer : 'none' });
      try { if (window.clarity) { window.clarity('set', 'cart_position', pos); window.clarity('event', 'add_position_' + pos); } } catch (err) {}
    }).catch(function () {});
  }
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (RE.test(url)) p.then(function (r) { if (r && r.ok) report(); }).catch(function () {});
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open, origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__apCartAdd = RE.test(String(url)); return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__apCartAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) report(); });
    return origSend.apply(this, arguments);
  };
})();
